import React, { FC, useState } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import ConfirmationButtons from '../../../ConfirmationButtons/ConfirmationButtons';
import CustomDialog from '../../../../common/components/CustomDialog';
import { formatDate, getFullName, IBusiness } from '../../utils/utils';
import BusinessDetailHeader from '../../Header/BusinessDetailHeader';
import CustomSelect from '../../../../common/components/CustomSelect';
import { GET_ENSEIGNES_WITH_ENTITIES } from '../../../../graphql/enseigne/query';
import { useQuery } from '@apollo/react-hooks';
import {
  SortOrder,
  TypeEnseigne,
} from '../../../../types/graphql-global-types';
import { OptionType } from '../../../../common/components/CustomSelect/CustomSelect';
import {
  EnseignesWithEntities,
  EnseignesWithEntitiesVariables,
} from '../../../../graphql/enseigne/types/EnseignesWithEntities';

interface Params {
  handleClose(): void;
  businessState: IBusiness;
  setBusinessState: React.Dispatch<React.SetStateAction<IBusiness>>;
}

const EditBusinessBankModal: FC<Params> = (props) => {
  const { handleClose, businessState, setBusinessState } = props;
  const [selectedBankId, setSelectedBankId] = useState<number>(
    businessState.bank?.id || 0,
  );

  const { data, loading } = useQuery<
    EnseignesWithEntities,
    EnseignesWithEntitiesVariables
  >(GET_ENSEIGNES_WITH_ENTITIES, {
    variables: {
      input: {
        where: {
          type: TypeEnseigne.BANK,
        },
        orderBy: { name: SortOrder.asc },
      },
    },
  });

  const allBanks: OptionType[] =
    data?.allEnseignes?.enseignes?.map((enseigne) => {
      return { value: enseigne?.id ?? -1, label: enseigne?.name ?? '' };
    }) ?? [];

  const handleChangeBank = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    const value = event.target.value;
    setSelectedBankId(value as number);
  };

  const handleConfirm = () => {
    const selectedBank = allBanks.find((bank) => bank.value === selectedBankId);

    if (selectedBank) {
      setBusinessState((prev) => {
        return {
          ...prev,
          bank: {
            id: Number(selectedBank.value),
            name: selectedBank.label,
          },
        };
      });
    }

    handleClose();
  };

  return (
    <CustomDialog
      loading={false}
      maxWidth="sm"
      onClose={handleClose}
      open={true}>
      <BusinessDetailHeader
        fullName={getFullName({
          firstName: businessState.firstName,
          lastName: businessState.lastName,
        })}
        apaName={getFullName({
          firstName: businessState.apa.firstName,
          lastName: businessState.apa.lastName,
        })}
        mandataryName={getFullName({
          firstName: businessState.mandatary?.firstName || '',
          lastName: businessState.mandatary?.lastName || '',
        })}
        createdAt={formatDate(businessState.createdAt)}
        apaEnseigneName={businessState.apa.enseigneName}
        status={businessState.step.label}
      />

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={100}
        pt={2}
        pb={2}>
        {loading ? (
          <CircularProgress size={22} />
        ) : (
          <CustomSelect
            label="Sélectionner une banque"
            value={selectedBankId}
            options={allBanks}
            onChange={handleChangeBank}
          />
        )}
      </Box>

      <ConfirmationButtons
        handleCancel={handleClose}
        handleConfirm={handleConfirm}
      />
    </CustomDialog>
  );
};

export default EditBusinessBankModal;
